import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { Endpoints } from "src/app/shared/config/endpoints";
import { AppState } from "src/app/store/app.state";
import { SignupLoginService } from "./../signupLogin.service";

@Injectable({
  providedIn: "root",
})
export class TeamsService {
  url = this.endpoint.signUpEndpoint;
  peopleSvc = this.endpoint.peopleEndpoint;
  org;
  user;
  userID;
  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    private signupSrv: SignupLoginService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.org = info.organization;
      this.userID = info.user.id;
      this.user = info.user;
    });
  }

  /**
   * Error Handler
   */
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  /**
   * Create Team(s)
   * @param payload
   */
  createTeam(payload): Observable<any> {
    return this.http.post<any>(this.peopleSvc + "/addTeam", payload);
  }

  /**
   * Updating Teams
   * @param payload
   */
  updateTeam(payload) {
    let url = this.peopleSvc + "/update/team";
    return this.http.post(url, payload);
  }

  /**
   * Getting all teams
   */
  fetchAllTeams() {
    return this.http.get(this.peopleSvc + "/allTeams/" + this.org.id); // Doesnt exist again i think
  }

  getTeamsByOrganization(type) {
    const url = `${this.peopleSvc}/teams/organization/${this.org.id}/${type}`;
    return this.http.get(url);
  }

  fetchAllTeamsIncludeSelf() {
    const req = this.http.get(
      this.url + "/getAllTeamsIncludingSelf/" + this.org.id
    );
    return this.signupSrv.mapTeamSelf(req, { teamIdKey: "id" });
  }

  /**
   * Fetch Team By ID
   * @param id
   */
  fetchTeamId(id) {
    try {
      return this.http
        .get(this.peopleSvc + `/getTeam/${id}`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   * Adding SalesPerson
   * @param param0
   */
  addSalesperson({ teamID, salesPerson }) {
    const body = {
      orgID: this.org.id,
      teamID,
      salesPerson,
    };
    return this.http.post(this.url + "/teamMembers", body);
  }

  /**
   * Fetch all team memebers of the Teams By ID
   * @param teamId
   */
  fetchTeamMembers(teamId) {
    return this.http.get(this.peopleSvc + `/getMembersByTeamID/${teamId}/${this.org.id}`);
  }

  assignTeamLead(body) {
    const url = this.url + `/assignTeamLead/${body.teamID}/${body.leadID}`;
    return this.http.post(url, body);
  }

  /**
   *new Teams Custom Filter
   * @param POST
   */
  newTeamsPersonCustomFilter(body) {
    const payload = { ...body, orgID: this.org.id, userID: this.userID };
    return this.http.post(this.peopleSvc + "/newTeamCustomFilter", payload);
  }

  /**
   *FETCH Teams Custom Filter
   * @param GET
   */
  fetchAllTeamsFilter() {
    const url = `${this.peopleSvc}/${this.org.id}/${this.userID}/getTeamCustomFilters`;
    return this.http.get(url);
  }

  /**
   *GET Filtered Teams
   * @param GET
   */
  getFilteredTeams(id) {
    const url = `${this.peopleSvc}/${id}/getFilteredTeams`;
    // const url = `${this.peopleSvc}/${id}/${this.org.id}/${this.userID}/getFilteredTeams`;
    return this.http.get(url);
  }

  /**
   * Filtered Teams By Number Of Invoices
   * @param data
   */
  getFilteredTeamsByNumberOfInvoices(data: { from; to }) {
    const url = `${this.peopleSvc}/${data.from}/${data.to}/${this.org.id}/getFilteredTeamsByNumberOfInvoices`;
    return this.http.get(url);
  }

  /**
   * Filtered Teams By Deal Types
   * @param data
   */
  getFilteredTeamsByDeal(data: { from; to }) {
    const url = `${this.peopleSvc}/${data.from}/${data.to}/${this.org.id}/getFilteredTeamsByNoOfDeals`;
    return this.http.get(url);
  }

  /**
   * Filtered Teams By Deal Won
   * @param data
   */
  FilteredSalesPersonsByNumberOfDealsWon(data: { from; to }) {
    const url = `${this.peopleSvc}/${data.from}/${data.to}/${this.org.id}/getFilteredTeamsByNoOfDealsWon`;
    return this.http.get(url);
  }

  /**
   * Filtered Teams By Deal Lost
   * @param data
   */
  FilteredSalesPersonsByNumberOfDealsLost(data: { from; to }) {
    const url = `${this.peopleSvc}/${data.from}/${data.to}/${this.org.id}/getFilteredTeamsByNoOfDealsLost`;
    return this.http.get(url);
  }

  /**
   *GET Teams Custom Filter by ID
   * @param GET
   */
  getTeamsCustomFilter(id) {
    // const url = `${this.peopleSvc}/${id}/${this.org.id}/${this.userID}/getTeamCustomFilter`;
    const url = `${this.peopleSvc}/${id}/getTeamCustomFilter`;
    return this.http.get(url);
  }

  /**
   *EDIT Teams Custom Filter
   * @param POST
   */
  updateTeamCustomFilter(body) {
    const payload = { ...body, orgID: this.org.id, userID: this.userID };
    return this.http.post(this.peopleSvc + "/updateTeamCustomFilter", payload);
  }

  /**
   *GET Teams Custom Filter BY ID
   * @param GET
   */
  fetchFilteredTeams(id) {
    return this.http.get(
      this.peopleSvc + `/${id}/${this.org.id}/${this.userID}/getFilteredTeams`
    );
  }

  /**
   * Assign Sales Territory
   * @param ids
   */
  assignSalesTerritory2(teamID, ids) {
    const path = `/team/salesTerritory/${ids}/${teamID}/${this.org.id}`;
    return this.http.post(this.url + path, {});
  }

  assignSalesTerritory(payload) {
    const url = `${this.peopleSvc}/team/salesTerritory/`;
    return this.http.post(url, payload);
  }

  /**
   *  Fetch Assign Sales Territory
   * @param teamID
   */
  getAssignSalesTerritory(teamID) {
    return this.http.get(
      this.url + `/teamSalesTerritories/${teamID}/${this.org.id}`
    );
  }

  /**
   * SEARCH TEAM FOR UNIVERSAL SEARCH
   * @param value
   */
  searchTeam(value) {
    const req = this.http.get(
      this.peopleSvc + `/searchAllTeams/${value}/${this.org.id}`
    );
    return this.signupSrv.mapTeamSelf(req);
  }

  /**
   *DELETE Teams Custom Filter BY ID
   * @param DELETE
   */
  deleteTeamCustomFilter(id) {
    return this.http.delete(this.peopleSvc + `/${id}/deleteTeamCustomFilter`);
  }

  /**
   *DELETE Teams Member
   * @param DELETE
   */
  deleteTeamMember(memberID) {
    return this.http.delete(this.peopleSvc + `/deleteTeamMember/${memberID}`);
  }

  /**
   * Delete Team SalesTerritory Filter By ID
   * @param id
   */
  deleteTeamTerritory(id) {
    const url = `${this.peopleSvc}/removeTeamSalesTerritory/${id}`;
    return this.http.delete(url);
  }

  updateGroup(payload){
    return this.http.post<any>(this.peopleSvc + "/update/group", payload);
  }
}
